module.exports = __webpack_public_path__ + "static/media/icon-pencil-white.cf770889.svg";